$(document).ready(function() {
	if(!document.querySelector('.GPC0016')) return false;

	if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
	} else {
		var $obj=$('.GPC0016');
		ePrivacyCookies.view('load', '', $obj.find('div[data-bv-show=questions]'));
	}
});